<template>
  <div data-module="work-two-column-text">
    <div class="module-layout">
      <div class="content-left"
        v-if="hasContentLeft"
        :class="contentContainerClasses"
      >
        <markdown class="markdown">{{data.contentLeft}}</markdown>
      </div>
      <div class="content-right"
        v-if="hasContentRight"
        :class="contentContainerClasses"
      >
        <markdown class="markdown">{{data.contentRight}}</markdown>
      </div>
    </div>
  </div>
</template>


<script>

import WorkMixin from './WorkMixin';

export default {

  name: 'work-two-column-text',

  props: ['data'],

  mixins: [WorkMixin],

  computed: {

    hasContentLeft() {
      const { contentLeft } = this.data;
      return (contentLeft !== undefined);
    },

    hasContentRight() {
      const { contentRight } = this.data;
      return (contentRight !== undefined);
    },

    containerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      const { isReversed } = this;

      let deviceStr = '';
      if (this.isMobile) {
        deviceStr = 'mobile';
      } else if (this.isTablet) {
        deviceStr = 'tablet';
      } else {
        deviceStr = 'desktop';
      }
      return (isReversed) ? `${deviceStr} reversed` : deviceStr;
    },

    contentContainerClasses() {
      // return class string, eg 'desktop', 'mobile.reversed'
      const classStr = this.containerClasses;
      const { data } = this;
      const { isOffset } = data;

      // add defaults
      const offset = (isOffset) ? 'offset' : 'equal';

      return `${classStr} ${offset}`;
    },

  },
};
</script>


<style lang="scss" scoped>
@import '~@/styles/_mixins.scss';
@import '~@/styles/_grid.scss';

$layout--percentage: $layout--max-content-width-ng / $layout--optimal-desktop * 100%;

[data-module="work-two-column-text"] {
  width: 100%;

  // media query props
  margin-bottom: rem($layout--default-module-spacing-mobile);

  @include ngMq($nbp--tablet, up) {
    margin-bottom: rem($layout--default-module-spacing-tablet);
  }

  @include ngMq($nbp--desktop, up) {
    margin-bottom: rem($layout--default-module-spacing-desktop);
  }

  .module-layout {
    // media query props
    @include ngGrid('mobile');

    @include ngMq($nbp--tablet, up) {
      @include ngGrid('tablet');
    }

    @include ngMq($nbp--desktop, up) {
      @include ngGrid('desktop');
    }

    // mobile

    .content-left.mobile,
    .content-right.mobile.reversed {
      grid-row: 1;
      margin: 0;
    }
    .content-right.mobile,
    .content-left.mobile.reversed {
      grid-row: 2;
      margin: 0;
    }

    .content-left.mobile.equal,
    .content-right.mobile.equal,
    .content-left.mobile.offset,
    .content-right.mobile.offset {
      grid-column: 1 / span 6;
    }

    // tablet

    .content-left.tablet,
    .content-right.tablet {
      grid-row: 1;
      margin: 0;

      // flex, to allow content to center
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    // tablet equal

    .content-left.tablet.equal,
    .content-right.tablet.equal.reversed {
      grid-column: 2 / span 5;
    }
    .content-right.tablet.equal,
    .content-left.tablet.equal.reversed {
      grid-column: 7 / span 5;
    }

    // tablet offset

    .content-left.tablet.offset {
      grid-column: 2 / span 6;
    }
    .content-right.tablet.offset {
      grid-column: 8 / span 4;
    }

    .content-left.tablet.offset.reversed {
      grid-column: 6 / span 6;
    }
    .content-right.tablet.offset.reversed {
      grid-column: 2 / span 4;
    }


    // desktop

    .content-left.desktop,
    .content-right.desktop {
      grid-row: 1;
      margin: 0;

      // flex, to allow content to center
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    // desktop equal

    .content-left.desktop.equal,
    .content-right.desktop.equal.reversed {
      grid-column: 2 / span 5;
    }
    .content-right.desktop.equal,
    .content-left.desktop.equal.reversed {
      grid-column: 7 / span 5;
    }

    // desktop offset

    .content-left.desktop.offset {
      grid-column: 2 / span 6;
    }
    .content-right.desktop.offset {
      grid-column: 8 / span 4;
    }

    .content-left.desktop.offset.reversed {
      grid-column: 6 / span 6;
    }
    .content-right.desktop.offset.reversed {
      grid-column: 2 / span 4;
    }



    .content-right {
      // handle module-layout grid
      grid-row: 2;
      grid-column: 1 / -1;
      margin-left: 0;
      margin-right: 0;

    }

  }
}
</style>



// WEBPACK FOOTER //
// src/modules/work/TwoColumnText.vue